import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge only knows Tailwind's own utilities. The design-system
 * typography classes in styles/app.css (`text-body-regular`, `text-h3-medium`,
 * …) look like `text-<colour>` to it, so `cn('text-body-regular text-neutral-7')`
 * silently dropped the typography class and the element fell back to the
 * browser's 16px/24px default. Register them as font-size utilities so they
 * only conflict with each other (and with `text-sm`, `text-[14px]`, …).
 * Add any new `.text-*` typography class from app.css here as well.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'h3-medium',
            'h5-medium',
            'h5-regular',
            'body-bold',
            'body-medium',
            'body-regular',
            'footnote-description',
            'footnote-monospace',
            'p-regular',
            's-regular',
          ],
        },
      ],
    },
  },
});

/**
 * Utility function to merge Tailwind classes
 * @param inputs - Class values to merge
 * @returns Merged class string
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
